<div hidden>
  <ng-template #loading>
    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
  </ng-template>
</div>
<!-- <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" id="userRoleExpansion">
  <mat-expansion-panel-header>
    <mat-panel-title> User Roles </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <br />
  <form [formGroup]="roleFormGroup" #authorizationForm="ngForm" id='authorizationForm' class='tabulator-footer'>

  <div *ngIf="userRoles$ | async as userRoles; else loading">
    <mat-form-field style="display:flex; justify-content:center;">
      <input type="text" placeholder="Your Role" aria-label="Number" matInput [matAutocomplete]="auto" formControlName="userRole" tabindex='-1'>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="roleDisplay.bind(userRoles)">
        <mat-option *ngFor="let role of userRoles" [value]="role.RoleGroupID">
          {{role.GroupName}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</form>
</mat-expansion-panel> -->

<form [formGroup]="roleFormGroup" #authorizationForm="ngForm" id='authorizationForm' class='tabulator-footer'>
  <div *ngIf="userRoles$ | async as userRoles; else loading">
    <button mat-menu-item style='font-size: 12px;' [matMenuTriggerFor]='userroles'>User Role ({{roleGroupName}})</button>
    <mat-menu #userroles="matMenu" (mouseover)="$event.stopPropagation();">
      <div *ngFor='let role of userRoles'>
        <button mat-menu-item (click)='roleChosen(role.RoleGroupID)' style='font-size: 12px;'>
          {{role.GroupName}}
        </button>
      </div>
    </mat-menu>
  </div>
</form>
